class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);



document.addEventListener('click', async (event) => {
  const swatch = event.target.closest('.cart-colour-swatch');
  if (!swatch) return;

  const wrapper = swatch.closest('.cart-colour-swatches');

  const line = parseInt(swatch.dataset.line, 10);
  const quantity = parseInt(swatch.dataset.quantity, 10);
  const newVariantId = parseInt(swatch.dataset.variantId, 10);

  wrapper?.classList.add('is-loading');

  document.querySelectorAll('.cart-colour-swatch')
    .forEach(el => el.classList.remove('is-pending'));

  swatch.classList.add('is-pending');

  try {
    const cart = await fetch('/cart.js').then(res => res.json());

    const currentItem = cart.items[line - 1];
    if (!currentItem) return;

    await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        line,
        quantity: 0
      })
    });


    await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: [{
          id: newVariantId,
          quantity,
          properties: currentItem.properties
        }]
      })
    });

    const sectionsToRender = [
      'cart-drawer',
      'cart-icon-bubble'
    ];

    const response = await fetch(`/?sections=${sectionsToRender.join(',')}`);
    const sections = await response.json();

    const drawerElement = document.querySelector('cart-drawer');

    if (drawerElement && sections['cart-drawer']) {
      const parsedDrawer = new DOMParser()
        .parseFromString(sections['cart-drawer'], 'text/html');

      const newDrawer = parsedDrawer.querySelector('cart-drawer');

      if (newDrawer) {
        drawerElement.innerHTML = newDrawer.innerHTML;
      }
    }

    const bubble = document.getElementById('cart-icon-bubble');

    if (bubble && sections['cart-icon-bubble']) {
      const parsedBubble = new DOMParser()
        .parseFromString(sections['cart-icon-bubble'], 'text/html');

      const newBubble = parsedBubble.getElementById('cart-icon-bubble');

      if (newBubble) {
        bubble.innerHTML = newBubble.innerHTML;
      }
    }

  } catch (error) {
    console.error('Variant switch failed:', error);

  } finally {
    wrapper?.classList.remove('is-loading');
    swatch.classList.remove('is-pending');
  }
});



